import cx from "classnames";
import React from "react";
import styles from "./searchableListHeader.module.scss";
import { gaImages } from "../../assets/globalConstants";
import { ImageModel, ISearchSelectorOptModel } from "../../types/interfaces";
import SearchBar from "../searchBar/SearchBar";
import Selector from "../Selector/Selector";

type SearchableListHeaderProps = {
  className?: string;
  icon?: ImageModel;
  placeholder?: string;
  optionsFilter: ISearchSelectorOptModel[];
  selectedOption: ISearchSelectorOptModel;
  searchValue: string;
  setSelectedOption: (x?: any) => void;
  handleSearchedChange: (x?: any) => void;
  cleanSearchBar: (x?: any) => void;
  handleSearchedValidation: ((x?: any) => void) | void | null;
  searchValueOnSelectorChange: (x?: any) => void;
};

const SearchableListHeader: React.FC<SearchableListHeaderProps> = React.memo(
  (props) => {
    const {
      className,
      icon,
      placeholder,
      optionsFilter,
      selectedOption,
      searchValue,
      setSelectedOption,
      handleSearchedChange,
      cleanSearchBar,
      handleSearchedValidation,
      searchValueOnSelectorChange,
    } = props;

    // Functions
    const onItemClick = (selectedOption) => {
      setSelectedOption(selectedOption);
      searchValueOnSelectorChange(selectedOption);
    };

    return (
      <div className={cx(styles.searchableListHeader, className && className)}>
        <div className={styles.searchbar__container}>
          <SearchBar
            className={cx("width100 margin-left-auto")}
            icon={icon || gaImages.searchBar}
            placeholder={placeholder || "public.search"}
            handleSearchedChange={handleSearchedChange}
            cleanIcon={true}
            searchValue={searchValue}
            cleanSearchBar={cleanSearchBar}
            handleSearchedValidation={handleSearchedValidation}
          />
          <Selector
            className={styles.selectCustomContainer}
            options={optionsFilter}
            selectedOption={selectedOption}
            setSelectedOption={onItemClick}
          />
        </div>
      </div>
    );
  }
);

export default SearchableListHeader;
